<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15.68 16.04h-.01.01zM16 9.51a3.91 3.91 0 00-3.9 3.9 1 1 0 102 0 2 2 0 011.9-1.95 2 2 0 01.85 3.71A3.15 3.15 0 0015 18v.32a1 1 0 101.95 0V18a1.2 1.2 0 01.74-1.06A3.91 3.91 0 0016 9.51z"/><circle cx="16" cy="21.51" r=".97"/><path d="M16 5A11 11 0 115 16 11 11 0 0116 5m0-2a13 13 0 1013 13A13 13 0 0016 3z"/></svg>